module.exports = __webpack_public_path__ + "img/foreword_1.d0d9d752.jpg";